import { colors } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const FlexWrapper = styled.div`
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: space-between;
	align-items: center;
	border-bottom: 1px solid ${colors.grey200};
`;

export const NavDiv = styled.div`
	padding: 0 16px;
	button {
		height: 40px;
		font-size: 12px;
	}
`;

export const ContentDiv = styled.div`
	overflow: auto;
	padding: 1%;
	@media (max-width: 1920px) {
		height: 95%;
	}

	@media (max-width: 1536px) {
		height: 93%;
	}

	@media (max-width: 1440px) {
		height: 96%;
	}

	@media (max-width: 1366px) {
		height: 96%;
	}
`;
